import { render, staticRenderFns } from "./incl-contentPoolContentElement.vue?vue&type=template&id=4482c09e&scoped=true"
import script from "./incl-contentPoolContentElement.vue?vue&type=script&lang=js"
export * from "./incl-contentPoolContentElement.vue?vue&type=script&lang=js"
import style0 from "./incl-contentPoolContentElement.vue?vue&type=style&index=0&id=4482c09e&prod&lang=css"
import style1 from "./incl-contentPoolContentElement.vue?vue&type=style&index=1&id=4482c09e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4482c09e",
  null
  
)

export default component.exports